import { render, staticRenderFns } from "./points-cart.vue?vue&type=template&id=08b26d0b"
import script from "./points-cart.vue?vue&type=script&lang=js"
export * from "./points-cart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports